var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50006 12.3103H5.25006V15.2068H1.50006V12.3103Z",
    fill: "#DBDFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24988 12.3103H19.4999V15.2068H8.24988V12.3103Z",
    fill: "#DBDFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50006 18.1038H5.25006V21.0003H1.50006V18.1038Z",
    fill: "#DBDFF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24988 18.1038H19.4999V21.0003H8.24988V18.1038Z",
    fill: "#DBDFF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 0H4.875C2.18261 0 0 2.10734 0 4.70687C0 7.30641 2.18261 9.41374 4.875 9.41374H16.125C18.8174 9.41374 21 7.30641 21 4.70687C21 2.10734 18.8174 0 16.125 0ZM16.125 6.51721H4.875C3.83936 6.51721 3 5.70679 3 4.70687C3 3.70695 3.83936 2.89654 4.875 2.89654H16.125C17.1606 2.89654 18 3.70695 18 4.70687C18 5.70679 17.1606 6.51721 16.125 6.51721Z",
    fill: "#DBDFF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentList);
export default __webpack_public_path__ + "static/media/studentList.18227ec9f04cd742801e03b194a89bb9.svg";
export { ForwardRef as ReactComponent };